(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      // V3 collection pages: the quick-filter nav sits ~10px under the header,
      // so an always-pinned header covers it at any rest position that isn't
      // exactly scroll-top. Fall back to Dawn's reveal-on-scroll-up behavior
      // there (with the early resetThreshold release below); every other page
      // keeps the merchant's "always" setting.
      this.hasQuickFiltersV3 = !!document.querySelector('.collection-quick-filters--v3');
      if (this.hasQuickFiltersV3) {
        this.headerIsAlwaysSticky = false;
      }
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // V3 quick-filter pages: an AJAX category swap can strand the header in a
      // pinned state on iOS (its scroll events during the swap resolve against a
      // mid-swap layout). Re-run the decision against the settled layout after
      // every swap; inside the top band, force the release.
      if (this.hasQuickFiltersV3) {
        const releaseHeader = () => {
          requestAnimationFrame(() => {
            this.refreshHeaderBounds();
            this.header.classList.remove('scrolled-past-header');
            this.reset();
          });
        };
        // filters-updated fires at fetch time; grid-swapped fires after the new
        // grid is actually applied (up to 1.5s later on the network path).
        // Each starts/extends a suspension window (see onScroll) and releases
        // the header immediately, so no pinned state can survive a swap.
        document.addEventListener('facets:filters-updated', () => {
          this.swapSuspendedUntil = Date.now() + 2500;
          releaseHeader();
        });
        document.addEventListener('facets:grid-swapped', () => {
          this.swapSuspendedUntil = Date.now() + 600;
          releaseHeader();
        });
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // Stock Dawn read these via a one-shot IntersectionObserver, but its
      // callback never fires on this theme (verified: headerBounds stayed {}),
      // which left hide/reveal dead. Measure synchronously instead — in page
      // coordinates, so a mid-page refresh still gets the true header band.
      const rect = this.header.getBoundingClientRect();
      this.headerBounds = {
        top: rect.top + window.scrollY,
        bottom: rect.bottom + window.scrollY,
      };
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // The band is measured once at connect, but the promo/marquee sections
      // above the header finish laying out later (fonts, marquee JS) and vary
      // by breakpoint — a stale band makes the reveal branch pin the header
      // over the v3 quick-filter nav at rest. Re-anchor it to the previous
      // section every tick: that sibling is never sticky/fixed, so this stays
      // correct even while the header itself is stuck or hidden.
      if (this.hasQuickFiltersV3) this.refreshHeaderBounds();

      // While a category swap is in flight, hold the header fully released:
      // the DOM swap can emit transient scroll adjustments (iOS especially)
      // whose direction reads as "scroll up", which would pin the header over
      // the quick-filter nav until something corrects it.
      if (this.hasQuickFiltersV3 && this.swapSuspendedUntil && Date.now() < this.swapSuspendedUntil) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.resetThreshold()) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    // Dawn keeps the revealed header pinned until scrollTop passes the header's
    // load-time TOP, leaving a dead band (banners + header height) where a rest
    // position parks the pinned header over the first ~64px of content. On v3
    // collection pages the quick-filter nav sits ~10px under the header, so it
    // gets stuck covered; release at the header's natural BOTTOM there instead.
    // Other pages keep the stock threshold (its handoff is pixel-seamless).
    resetThreshold() {
      return this.hasQuickFiltersV3 ? this.headerBounds.bottom : this.headerBounds.top;
    }

    refreshHeaderBounds() {
      const prev = this.header.previousElementSibling;
      if (!prev) return;
      const top = prev.getBoundingClientRect().bottom + window.scrollY;
      this.headerBounds = { top: top, bottom: top + this.header.offsetHeight };
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
